"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
// tslint:disable-next-line
var update = require("react-addons-update");
var values = require("lodash/values");
var Body_1 = require("./Body");
var GridSelection_1 = require("./GridSelection");
var HeaderRow_1 = require("./HeaderRow");
var RowHeaderCell_1 = require("./RowHeaderCell");
var Utils_1 = require("./Utils");
var DefaultScrollComponent_1 = require("./DefaultScrollComponent");
var ConfigDefaults = /** @class */ (function () {
    function ConfigDefaults() {
    }
    ConfigDefaults.rowOuterHeight = 38;
    ConfigDefaults.sectionRows = 20;
    ConfigDefaults.colsPerChunk = 10;
    ConfigDefaults.maxInitialColumnWidth = 200;
    ConfigDefaults.minimumColumnWidth = 39;
    ConfigDefaults.rememberLastScrollPos = false;
    return ConfigDefaults;
}());
exports.ConfigDefaults = ConfigDefaults;
var DataGrid = /** @class */ (function (_super) {
    __extends(DataGrid, _super);
    function DataGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mergedMeasuredColumnHeaderWidths = undefined;
        _this.mergedMeasuredColumnBodyWidths = undefined;
        _this.config = {};
        _this.scrollTop = 0;
        _this.defaultHeaderHeight = 37;
        _this.defaultAverageColumnWidth = 80;
        // tslint:disable-next-line
        _this.state = {
            measuredColumnHeaderWidths: undefined,
            measuredColumnBodyWidths: undefined,
            userSizedColumnWidths: {},
            columnWidths: undefined,
            averageColumnWidth: 0,
            scrollLeft: 0,
            rows: undefined,
            gridWidth: 0,
            fetchedRowsStartIndex: 0,
            fetchedRowsEndIndex: 0,
            bodySectionRenderRanges: {
                columnStart: 0,
                columnEnd: 0,
                rowStart: 0,
                rowEnd: 0
            }
        };
        _this.removeStaleColumnWidths = function (nextProps) {
            var trimmedColumnWidths = {};
            var trimmedMeasuredColumnHeaderWidths = {};
            var trimmedMeasuredColumnBodyWidths = {};
            nextProps.cols.forEach(function (col) {
                var columnKey = col.name;
                if (_this.state.columnWidths && _this.state.columnWidths[columnKey]) {
                    trimmedColumnWidths[columnKey] = _this.state.columnWidths[columnKey];
                }
                if (_this.state.measuredColumnHeaderWidths && _this.state.measuredColumnHeaderWidths[columnKey]) {
                    trimmedMeasuredColumnHeaderWidths[columnKey] = _this.state.measuredColumnHeaderWidths[columnKey];
                }
                if (_this.state.measuredColumnBodyWidths && _this.state.measuredColumnBodyWidths[columnKey]) {
                    trimmedMeasuredColumnBodyWidths[columnKey] = _this.state.measuredColumnBodyWidths[columnKey];
                }
            });
            _this.setState({
                columnWidths: trimmedColumnWidths,
                measuredColumnHeaderWidths: trimmedMeasuredColumnHeaderWidths,
                measuredColumnBodyWidths: trimmedMeasuredColumnBodyWidths
            });
        };
        _this.getGridClientRect = function () {
            return ReactDOM.findDOMNode(_this).getBoundingClientRect();
        };
        _this.onResize = function () {
            var columnWidths = _this.state.columnWidths || {};
            var defaultColumnWidth = _this.getStateAverageColumnWidth();
            var bodySectionRenderRanges = _this.getBodySectionRenderRanges(_this.state.scrollLeft, _this.scrollTop, columnWidths, defaultColumnWidth);
            _this.setState(Utils_1.assign({}, { gridWidth: Math.floor(_this.getGridClientRect().width) }, _this.getStateUpdateFromBodySectionRenderRanges(bodySectionRenderRanges)));
        };
        _this.fetch = function (start, end) {
            _this.fetchUsingProps(_this.props, start, end);
        };
        _this.fetchUsingProps = function (props, start, end) {
            if (props.rowStore) {
                props.rowStore.getItems(start, end, function (rows) {
                    if (!rows) {
                        return;
                    }
                    var stateUpdate = {
                        rows: rows,
                        fetchedRowsStartIndex: start,
                        fetchedRowsEndIndex: Math.max(end, start + rows.length)
                    };
                    _this.setState(stateUpdate, function () {
                        if (_this.props.updated) {
                            _this.props.updated(rows);
                        }
                    });
                });
            }
        };
        _this.onColumnResize = function (column, width) {
            var newColumnWidth = {};
            newColumnWidth[column.name] = width;
            _this.setState({
                userSizedColumnWidths: update(_this.state.userSizedColumnWidths, { $merge: newColumnWidth }),
                columnWidths: update(_this.state.columnWidths || {}, { $merge: newColumnWidth })
            });
        };
        _this.handleMeasuredColumnHeaderWidths = function (widths) {
            _this.mergedMeasuredColumnHeaderWidths = update(_this.state.measuredColumnHeaderWidths || {}, { $merge: widths });
            _this.updateStateForMeasuredColumnWidths();
        };
        _this.handleMeasuredColumnBodyWidths = function (widths) {
            _this.mergedMeasuredColumnBodyWidths = update(_this.state.measuredColumnBodyWidths || {}, { $merge: widths });
            _this.updateStateForMeasuredColumnWidths();
        };
        _this.handleBodyRef = function (body) {
            _this.body = body;
            _this.updateStateForMeasuredColumnWidths();
        };
        _this.getStateUpdateFromBodySectionRenderRanges = function (nextBodySectionRenderRanges) {
            var currentBodySectionRenderRanges = _this.state.bodySectionRenderRanges;
            if (nextBodySectionRenderRanges.rowStart === currentBodySectionRenderRanges.rowStart &&
                nextBodySectionRenderRanges.rowEnd === currentBodySectionRenderRanges.rowEnd &&
                nextBodySectionRenderRanges.columnStart === currentBodySectionRenderRanges.columnStart &&
                nextBodySectionRenderRanges.columnEnd === currentBodySectionRenderRanges.columnEnd) {
                return {};
            }
            if (nextBodySectionRenderRanges.rowStart !== currentBodySectionRenderRanges.rowStart ||
                nextBodySectionRenderRanges.rowEnd !== currentBodySectionRenderRanges.rowEnd) {
                _this.fetch(nextBodySectionRenderRanges.rowStart * _this.sectionRows, (nextBodySectionRenderRanges.rowEnd + 1) * _this.sectionRows - 1);
            }
            return { bodySectionRenderRanges: nextBodySectionRenderRanges };
        };
        _this.onBodyScroll = function (left, top) {
            _this.scrollTop = top;
            var bodySectionRenderRanges = _this.getBodySectionRenderRanges(left, top, _this.state.columnWidths || {}, _this.getStateAverageColumnWidth());
            var stateUpdate = _this.getStateUpdateFromBodySectionRenderRanges(bodySectionRenderRanges);
            if (left !== _this.state.scrollLeft) {
                Utils_1.assign(stateUpdate, { scrollLeft: left });
            }
            if (Object.keys(stateUpdate).length > 0) {
                _this.setState(stateUpdate);
            }
        };
        return _this;
    }
    DataGrid.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.onResize);
        var rect = this.getGridClientRect();
        var gridWidth = Math.floor(rect.width);
        var gridHeight = Math.floor(rect.height);
        var rowEnd = (Math.ceil(gridHeight / this.sectionHeight) + 1) * this.sectionRows - 1;
        this.setState({
            gridWidth: gridWidth,
            columnWidths: this.updateColumnWidths({}, {}, gridWidth)
        });
        this.fetchUsingProps(this.props, 0, rowEnd);
    };
    DataGrid.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onResize);
    };
    DataGrid.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.rowStore !== nextProps.rowStore) {
            // A new row store is created when order or filter params have changed, so
            // scroll to the top (unless user explicitly sets rememberLastScrollPos in the config).
            if (!!this.body) {
                this.body.onRowStoreChanged();
            }
        }
        this.removeStaleColumnWidths(nextProps);
        this.fetchUsingProps(nextProps, this.state.fetchedRowsStartIndex || 0, this.state.fetchedRowsEndIndex || 0);
    };
    /**
     * This method uses the measured column widths from the body and header components to determine each column's width.
     * Typically, a column width will be the maximum width of the two measurements. Using the column widths and the scroll
     * position we determine the range of columns and rows that will be rendered to the Virtual DOM. The range of columns
     * and rows will overlap the viewport on all sides.
     */
    DataGrid.prototype.updateStateForMeasuredColumnWidths = function () {
        var rows = this.state.rows || [];
        var haveColumnBodyWidthMeasurements = (rows.length === 0 || this.mergedMeasuredColumnBodyWidths);
        var haveColumnHeaderWidthMeasurements = (!this.props.showHeaders || this.mergedMeasuredColumnHeaderWidths);
        if (haveColumnBodyWidthMeasurements && haveColumnHeaderWidthMeasurements) {
            var gridWidth = this.state.gridWidth || Math.floor(this.getGridClientRect().width);
            var newColumnWidths = this.updateColumnWidths(this.mergedMeasuredColumnBodyWidths || {}, this.mergedMeasuredColumnHeaderWidths || {}, gridWidth);
            var newAverageColumnWidth = this.calculateAverageColumnWidth(newColumnWidths);
            var bodySectionRenderRanges = this.getBodySectionRenderRanges(this.state.scrollLeft, this.scrollTop, newColumnWidths, newAverageColumnWidth);
            var columnWidthsStateUpdate = {
                gridWidth: gridWidth,
                columnWidths: newColumnWidths,
                averageColumnWidth: newAverageColumnWidth,
                measuredColumnBodyWidths: Utils_1.assign({}, this.mergedMeasuredColumnBodyWidths),
                measuredColumnHeaderWidths: Utils_1.assign({}, this.mergedMeasuredColumnHeaderWidths)
            };
            this.setState(Utils_1.assign({}, columnWidthsStateUpdate, this.getStateUpdateFromBodySectionRenderRanges(bodySectionRenderRanges)));
        }
    };
    DataGrid.prototype.getScrollbarWidth = function () {
        if (!this.body || !this.state.rows) {
            return 0;
        }
        var totalRowHeight = this.rowOuterHeight * this.state.rows.length;
        var body = ReactDOM.findDOMNode(this.body);
        var bodyHeight = body.getBoundingClientRect().height;
        return (totalRowHeight > bodyHeight) ? Utils_1.measureScrollbarWidth(body) : 0;
    };
    DataGrid.prototype.updateColumnWidths = function (measuredColumnBodyWidths, measuredColumnHeaderWidths, gridWidth) {
        var _this = this;
        var maxInitialColumnWidth = this.config.maxInitialColumnWidth || ConfigDefaults.maxInitialColumnWidth;
        var columnWidths = {};
        var maxMeasuredColumnWidths = {};
        var totalWidth = 0;
        var cols = this.props.cols || [];
        cols.forEach(function (col) {
            var currentColumnBodyWidth;
            var currentColumnHeaderWidth;
            var columnKey = col.name;
            var maxColumnWidth = 0;
            if (_this.state.userSizedColumnWidths[columnKey]) {
                columnWidths[columnKey] = _this.state.userSizedColumnWidths[columnKey];
                totalWidth += columnWidths[columnKey];
            }
            else {
                if (!col.preferredWidth) {
                    currentColumnBodyWidth = measuredColumnBodyWidths[columnKey];
                    currentColumnHeaderWidth = measuredColumnHeaderWidths[columnKey];
                    maxColumnWidth = Math.max(currentColumnBodyWidth || 0, currentColumnHeaderWidth || 0);
                }
                maxMeasuredColumnWidths[columnKey] = col.preferredWidth || maxColumnWidth;
                if (col.preferredWidth || currentColumnBodyWidth || currentColumnHeaderWidth) {
                    var currentMaxInitialColumnWidth = (maxInitialColumnWidth < 0) ? maxMeasuredColumnWidths[columnKey] : maxInitialColumnWidth;
                    columnWidths[columnKey] = Math.min(maxMeasuredColumnWidths[columnKey], currentMaxInitialColumnWidth);
                    totalWidth += columnWidths[columnKey];
                }
            }
        });
        if (this.props.showRowHeaders) {
            totalWidth += RowHeaderCell_1.RowHeaderCell.Width;
        }
        // Allocating unused width in left-to-right column order, up to each columns's max width
        var extraAvailable = gridWidth - this.getScrollbarWidth() - (this.props.leftMargin || 0) - totalWidth;
        var growToFitCols = 0;
        for (var colIdx = 0; colIdx < cols.length && extraAvailable > 0; colIdx++) {
            var col = cols[colIdx];
            var maxColWidth = col.maxColumnWidth || maxMeasuredColumnWidths[col.name];
            var extraRequested = Math.min(maxColWidth, maxMeasuredColumnWidths[col.name]) - columnWidths[col.name];
            if (extraRequested > 0 && columnWidths[col.name] !== undefined) {
                var extraAllocated = Math.min(extraRequested, extraAvailable);
                columnWidths[col.name] += extraAllocated;
                extraAvailable -= extraAllocated;
            }
            if (col.growToFit) {
                growToFitCols += 1;
            }
        }
        // Allocate remaining width evenly to any growToFit columns
        if (extraAvailable > 0 && growToFitCols > 0) {
            var extraWidth_1 = extraAvailable / growToFitCols;
            cols.forEach(function (col) {
                if (col.growToFit && columnWidths[col.name] !== undefined) {
                    columnWidths[col.name] += extraWidth_1;
                }
            });
        }
        return columnWidths;
    };
    DataGrid.prototype.render = function () {
        this.config = this.props.config || {};
        this.colsPerChunk = this.config.colsPerChunk || ConfigDefaults.colsPerChunk;
        this.sectionRows = this.config.sectionRows || ConfigDefaults.sectionRows;
        this.rowOuterHeight = this.config.rowOuterHeight || ConfigDefaults.rowOuterHeight;
        this.sectionHeight = this.rowOuterHeight * this.sectionRows;
        this.minimumColumnWidth = this.config.minimumColumnWidth || ConfigDefaults.minimumColumnWidth;
        var cols = this.props.cols;
        var rows = this.state.rows;
        var columnWidths = this.state.columnWidths;
        var scrollLeft = this.state.scrollLeft || 0;
        var columnWidthInfo = this.getColumnWidthInfo();
        var bodySectionRenderRanges = this.state.bodySectionRenderRanges;
        var colStartIdx = bodySectionRenderRanges.columnStart * this.colsPerChunk;
        var colEndIdx = Math.min((bodySectionRenderRanges.columnEnd + 1) * this.colsPerChunk, this.props.cols.length) - 1;
        var isSelectionIndexBased = !!this.props.selectionData ? GridSelection_1.isSelectionDataIndexBased(this.props.selectionData) : false;
        var children = [];
        if (Array.isArray(rows)) {
            if (this.props.showHeaders) {
                children.push(HeaderRow_1.HeaderRow.element({
                    key: 'header',
                    cols: cols,
                    colStartIdx: colStartIdx,
                    colEndIdx: colEndIdx,
                    minColWidth: this.minimumColumnWidth,
                    columnWidths: columnWidths || this.getProvisionalColumnWidths(),
                    leftMargin: columnWidthInfo.leftSpacer + (this.props.leftMargin || 0),
                    sortKey: this.props.sortKey,
                    sortAscending: this.props.sortAscending !== false,
                    onColumnHeaderClick: this.props.onColumnHeaderClick,
                    showRowHeaderCell: this.props.showRowHeaders,
                    onRowHeaderCellClick: this.props.showRowHeaders ? this.props.onSelectAllButtonClick : undefined,
                    onHeaderClicked: this.props.onHeaderClicked,
                    onHeaderDoubleClick: this.props.onHeaderDoubleClick,
                    onHeaderContextMenu: this.props.onHeaderContextMenu,
                    measuredColumnWidths: this.state.measuredColumnHeaderWidths || {},
                    measureColumnWidths: this.handleMeasuredColumnHeaderWidths,
                    scrollLeft: scrollLeft,
                    onColumnResize: this.onColumnResize,
                    selectionData: this.props.selectionData,
                    isSelectionDataIndexBased: isSelectionIndexBased
                }));
            }
            children.push(Body_1.Body.element({
                key: 'body',
                showHeaders: this.props.showHeaders,
                headerHeight: this.props.headerHeight || this.defaultHeaderHeight,
                showRowHeaders: this.props.showRowHeaders,
                showHorizontalGridLines: this.props.showHorizontalGridLines,
                showVerticalGridLines: this.props.showVerticalGridLines,
                cols: cols,
                columnWidths: columnWidths,
                leftMargin: this.props.leftMargin,
                leftSpacer: columnWidthInfo.leftSpacer,
                sectionHeight: this.sectionHeight,
                measuredColumnWidths: this.state.measuredColumnBodyWidths || {},
                measureColumnWidths: this.handleMeasuredColumnBodyWidths,
                onBodyScroll: this.onBodyScroll,
                rows: rows,
                emptyChild: this.props.emptyChild,
                requestedFocusedRowIndex: this.props.requestedFocusedRowIndex,
                selectionData: this.props.selectionData,
                isSelectionDataIndexBased: isSelectionIndexBased,
                rowStylist: this.props.rowStylist,
                onCellClick: this.props.onCellClick,
                onCellDoubleClick: this.props.onCellDoubleClick,
                onCellContextMenu: this.props.onCellContextMenu,
                onRowClick: this.props.onRowClick,
                onRowFocused: this.props.onRowFocused,
                ref: this.handleBodyRef,
                scrollComponent: this.props.scrollComponent || DataGrid.defaultScroller,
                scrollingRootId: this.props.scrollingRootId,
                onIScrollableRefUpdate: this.props.scrollableHandler,
                rowOuterHeight: this.config.rowOuterHeight || ConfigDefaults.rowOuterHeight,
                colsPerChunk: this.config.colsPerChunk || ConfigDefaults.colsPerChunk,
                sectionRows: this.config.sectionRows || ConfigDefaults.sectionRows,
                rememberLastScrollPos: this.config.rememberLastScrollPos || ConfigDefaults.rememberLastScrollPos,
                bodySectionRenderRanges: this.state.bodySectionRenderRanges,
                totalColumnWidth: columnWidthInfo.totalColumnWidth
            }));
        }
        return (React.createElement("div", { className: 'tb-react-data-grid', tabIndex: 0, style: { outline: 'none' } }, children));
    };
    /**
     * This method uses the scroll position and column widths to determine the range of columns and rows that will
     * be rendered to the Virtual DOM. The range of columns and rows will overlap the viewport on all sides. The
     * first and last column/row indices are then normalized against the first and last column/row indices for the
     * corresponding bandings.
     */
    DataGrid.prototype.getBodySectionRenderRanges = function (scrollLeft, scrollTop, colWidths, defaultColumnWidth) {
        var cols = this.props.cols;
        var rect = ReactDOM.findDOMNode(this.body ? this.body : this).getBoundingClientRect();
        var viewportTop = Math.max(scrollTop, 0);
        var viewportBottom = viewportTop + rect.height;
        var viewportLeft = Math.max(scrollLeft, 0);
        var viewportRight = viewportLeft + rect.width;
        var columnStart = undefined;
        var columnEnd = undefined;
        var runningTotal = 0;
        for (var colIdx = 0; colIdx < cols.length; colIdx++) {
            var colWidth = colWidths[cols[colIdx].name] || defaultColumnWidth;
            runningTotal += colWidth;
            viewportLeft -= colWidth;
            viewportRight -= colWidth;
            if (columnStart === undefined && viewportLeft <= 0) {
                columnStart = Math.floor(colIdx / this.colsPerChunk);
            }
            if (columnEnd === undefined && (viewportRight <= 0 || (colIdx + 1 === cols.length))) {
                columnEnd = Math.ceil(colIdx / this.colsPerChunk);
                break;
            }
        }
        var rowStart = Math.floor(viewportTop / this.sectionHeight);
        var rowEnd = Math.ceil(viewportBottom / this.sectionHeight);
        return {
            columnStart: columnStart,
            columnEnd: columnEnd,
            rowStart: rowStart,
            rowEnd: rowEnd
        };
    };
    // getProvisionalColumnWidths is used when we have no data rows, so can't
    // measure the width of the data columns. We just choose reasonable widths for
    // the headers.
    DataGrid.prototype.getProvisionalColumnWidths = function () {
        var _this = this;
        // Only compute provisional column widths if the header widths have already
        // been measured
        if (!this.state.measuredColumnHeaderWidths) {
            return null;
        }
        // Find the total width of the measured headers
        var totalWidth = 0;
        var numberOfResizableColumns = 0;
        var cols = this.props.cols || [];
        cols.forEach(function (col) {
            if (col.preferredWidth) {
                totalWidth += col.preferredWidth;
            }
            else {
                if (_this.state.measuredColumnHeaderWidths) {
                    totalWidth += _this.state.measuredColumnHeaderWidths[col.name];
                }
            }
            if (col.resizable !== false) {
                // default (undefined) is resizable
                numberOfResizableColumns++;
            }
        });
        if (this.props.showRowHeaders) {
            totalWidth += RowHeaderCell_1.RowHeaderCell.Width;
        }
        // Allocate any extra space evenly between the resizable headers
        var extraAvailable = this.state.gridWidth - this.getScrollbarWidth() - totalWidth;
        var provisionalColumnWidths = {};
        if (extraAvailable > 0 && numberOfResizableColumns > 0) {
            var extraPerHeader_1 = extraAvailable / numberOfResizableColumns;
            cols.forEach(function (col) {
                if (col.resizable !== false) {
                    // default (undefined) is resizable
                    var width = 0;
                    if (col.preferredWidth) {
                        width = col.preferredWidth;
                    }
                    else {
                        if (_this.state.measuredColumnHeaderWidths) {
                            width = _this.state.measuredColumnHeaderWidths[col.name];
                        }
                    }
                    provisionalColumnWidths[col.name] = width + extraPerHeader_1;
                }
            });
        }
        return provisionalColumnWidths;
    };
    DataGrid.prototype.getColumnWidthInfo = function () {
        var columnWidthInfo = {
            leftSpacer: 0,
            totalColumnWidth: 0
        };
        var columnWidths = this.state.columnWidths || {};
        if (Object.keys(columnWidths).length === 0) {
            return columnWidthInfo;
        }
        var defaultColumnWidth = this.getStateAverageColumnWidth();
        var columnStartIndex = this.state.bodySectionRenderRanges.columnStart * this.colsPerChunk;
        var totalColumnWidth = this.props.showRowHeaders ? RowHeaderCell_1.RowHeaderCell.Width : 0;
        for (var colIdx = 0; colIdx < this.props.cols.length; colIdx++) {
            totalColumnWidth += columnWidths[this.props.cols[colIdx].name] || defaultColumnWidth;
            if (columnStartIndex !== 0 && (colIdx + 1 === columnStartIndex)) {
                columnWidthInfo.leftSpacer = totalColumnWidth;
            }
        }
        columnWidthInfo.totalColumnWidth = totalColumnWidth;
        return columnWidthInfo;
    };
    DataGrid.prototype.getStateAverageColumnWidth = function () {
        return Math.max(this.state.averageColumnWidth || 0, this.defaultAverageColumnWidth);
    };
    DataGrid.prototype.calculateAverageColumnWidth = function (columnWidths) {
        if (Object.keys(columnWidths).length === 0) {
            return this.defaultAverageColumnWidth;
        }
        var columns = 0;
        var sum = values(columnWidths).reduce(function (a, b) {
            columns++;
            return a + b;
        }, 0);
        var averageColumnWidth = Math.ceil(sum / columns);
        return Math.max(averageColumnWidth, this.defaultAverageColumnWidth);
    };
    DataGrid.defaultScroller = DefaultScrollComponent_1.DefaultScrollComponent;
    DataGrid.displayName = 'DataGrid';
    DataGrid.element = React.createFactory(DataGrid);
    DataGrid.defaultProps = {
        cols: [],
        hackyUpdate: 0,
        showHorizontalGridLines: true,
        showVerticalGridLines: false,
        showHeaders: true,
        // tslint:disable-next-line
        onRowFocused: function (row, rowIndex) { }
    };
    return DataGrid;
}(React.Component));
exports.DataGrid = DataGrid;
(function (DataGrid) {
    DataGrid.DefaultHeaderHeight = 37;
})(DataGrid = exports.DataGrid || (exports.DataGrid = {}));
exports.DataGrid = DataGrid;
//# sourceMappingURL=DataGrid.js.map